import { render, staticRenderFns } from "./PanelDeleteConfirmPopUp.vue?vue&type=template&id=6f83d26f&"
import script from "./PanelDeleteConfirmPopUp.vue?vue&type=script&lang=ts&"
export * from "./PanelDeleteConfirmPopUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports